<h1 mat-dialog-title class="dialog-title-before-none">{{ data?.pageTitle }}
  <!-- Search box -->
  <div>
    <mat-form-field appearance="outline" style="width: 100%; font-size: 14px; margin-top: 1rem;">
      <mat-label>Search Incident Types</mat-label>
      <mat-icon class="align-middle" matIconPrefix>search</mat-icon>
      <input matInput type="search" [(ngModel)]="filterText" (ngModelChange)="filterChanged()">
    </mat-form-field>
  </div>
</h1>

<mat-dialog-content>
  <!-- Display area -->
  <div class="min-height" *ngIf="!typesLoading">
    <mat-action-list>
      <button mat-list-item *ngFor="let type of filteredTypes" (click)="onTypeSelect(type)">
        <mat-icon class="icon-space align-middle {{ type.classification.id === 2 ? 'icon-blue' : 'icon-red' }}">
          {{ type.classification.id === 2 ? "assignment" : "assignment_late" }}
        </mat-icon> 
        <span id="singleIncidentType">{{ type.name.values[locale.language] }} ({{ type.category.name }})</span>
      </button>
    </mat-action-list>
  </div>

  <!-- Spinner -->
  <div *ngIf="typesLoading" class="min-height">
    <mat-progress-spinner mode="indeterminate" style="margin:0 auto;"></mat-progress-spinner>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button id="cancel" color="primary" (click)="onCancelClick()">{{ 'Cancel' | translate:locale.language }}</button>
</mat-dialog-actions>
